// Loading.js
import React from 'react';
import '../../styles/Loading.scss'; // Import CSS for styling

function Loading() {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
      <div className="loading-text">Loading...</div>
    </div>
  );
}

export default Loading;
